var map = {
	"./localisation.js": "bhc5",
	"./logs.js": "0vli",
	"./menus.js": "WOl9",
	"./permissionGroups.js": "Z+EA",
	"./permissions.js": "HifB",
	"./roles.js": "nKP4",
	"./tutorials.js": "rzf2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sHRI";


//////////////////
// WEBPACK FOOTER
// ./resources/js/routes/system nonrecursive .*\.js$
// module id = sHRI
// module chunks = 64 65 66